import { useState } from "react";
import { motion } from "framer-motion";

export default function AnomalyPlate({ plate, fallbackImage, code, testid }) {
  const [active, setActive] = useState(0);
  const img = plate.image || fallbackImage;

  return (
    <motion.div
      data-testid={testid}
      initial={{ opacity: 0, height: 0 }}
      animate={{ opacity: 1, height: "auto" }}
      exit={{ opacity: 0, height: 0 }}
      transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
      className="overflow-hidden"
    >
      <div className="relative mt-4 aspect-[16/10] overflow-hidden border border-[#D4AF37]/25 bg-black">
        <img
          src={img}
          alt=""
          className="h-full w-full object-cover transition-transform duration-[1200ms] ease-out"
          style={{
            transform: `scale(${plate.zoom})`,
            transformOrigin: `${plate.x}% ${plate.y}%`,
            filter: "saturate(0.7) contrast(1.1)",
          }}
        />
        <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-black/20" />
        <div className="pointer-events-none absolute inset-0 opacity-[0.12] mix-blend-overlay [background-image:linear-gradient(#D4AF37_1px,transparent_1px),linear-gradient(90deg,#D4AF37_1px,transparent_1px)] [background-size:25%_25%]" />
        <span className="absolute left-3 top-3 font-mono text-[8px] tracking-[0.3em] text-[#D4AF37]/80">
          FIG. {code} — ANNOTATED PLATE
        </span>
        {plate.pins.map((p, i) => (
          <button
            key={p.label}
            data-testid={`${testid}-pin-${i}`}
            onClick={() => setActive(i)}
            aria-label={p.label}
            className="absolute -translate-x-1/2 -translate-y-1/2"
            style={{ left: `${p.x}%`, top: `${p.y}%` }}
          >
            <span
              className={`relative flex h-6 w-6 items-center justify-center rounded-full border font-mono text-[9px] transition-all duration-300 ${
                active === i
                  ? "scale-110 border-[#FF9F1C] bg-[#FF9F1C] text-[#0B0C10]"
                  : "border-[#D4AF37] bg-[#0B0C10]/70 text-[#D4AF37] backdrop-blur"
              }`}
            >
              {i + 1}
              {active === i && (
                <span className="absolute inset-0 animate-ping rounded-full border border-[#FF9F1C]" />
              )}
            </span>
          </button>
        ))}
      </div>
      <ol className="mt-3 space-y-1.5">
        {plate.pins.map((p, i) => (
          <li
            key={p.label}
            data-testid={`${testid}-caption-${i}`}
            onClick={() => setActive(i)}
            className={`flex cursor-pointer items-baseline gap-3 font-mono text-[10px] leading-relaxed transition-colors duration-300 ${
              active === i ? "text-[#FF9F1C]" : "text-white/45 hover:text-white/70"
            }`}
          >
            <span className="shrink-0 tabular-nums">{String(i + 1).padStart(2, "0")}</span>
            <span className="tracking-[0.05em]">{p.label}</span>
          </li>
        ))}
      </ol>
    </motion.div>
  );
}
